import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { getI18n } from 'client/i18n'
import styles from './crowdfunding_banner.less'
import cssModules from 'react-css-modules'
import { baseUrl } from 'shared/campaign_url'
import { CROWD_FUNDING_HOME_URI } from 'shared/shared_consts'
import {
  blue200,
  Button,
  Col,
  Container,
  HeadingText,
  Icon,
  Row,
} from '@paypalcorp/pp-react'
import JsxParser from 'react-jsx-parser'

const i18n = getI18n('components/crowdfunding_banner')

export const MoneyPoolHeader = props => {
  const handleClick = () => {
    fetch(props.clickUrl)
  }

  useEffect(() => {
    const element = document.querySelector('.jsx-parser a')
    if (element && props.clickUrl) {
      element.addEventListener('click', handleClick)
      return () => {
        element.removeEventListener('click', handleClick)
      }
    }
  }, [])

  return (
    <JsxParser
      bindings={{
        banner_link: props.bannerLink,
      }}
      components={{ HeadingText }}
      jsx={`
			<HeadingText size="md">
				${props.bannerTitleText}
			</HeadingText>
			`}
    />
  )
}

MoneyPoolHeader.propTypes = {
  bannerLink: PropTypes.string,
  bannerTitleText: PropTypes.string,
  clickUrl: PropTypes.string,
}

class CrowdfundingBanner extends React.Component {
  static propTypes = {
    bannerButtonText: PropTypes.string,
    bannerIcon: PropTypes.string,
    bannerLink: PropTypes.string,
    bannerTitleText: PropTypes.string,
    cta: PropTypes.string,
    isLoggedIn: PropTypes.any,
    isMoneyPool: PropTypes.bool,
    analytics: PropTypes.object,
  }

  handleHelpNow = () => {
    const { bannerLink } = this.props
    const uri = bannerLink || CROWD_FUNDING_HOME_URI
    open(baseUrl(location.hostname, uri))
  }

  componentDidMount() {
    if (this.props.analytics?.impressionUrl) {
      fetch(this.props.analytics.impressionUrl)
    }
  }

  render() {
    const {
      bannerIcon,
      bannerButtonText,
      bannerLink,
      bannerTitleText,
      isMoneyPool,
      analytics,
    } = this.props
    // Don't show money pool banner if message is missing
    if ((!bannerTitleText || !bannerLink) && isMoneyPool) {
      return null
    }

    return (
      <Container
        fluid={true}
        styleName={
          this.props.isLoggedIn && !isMoneyPool ? 'entryBannerContainer' : ''
        }
        style={{ background: blue200 }}
      >
        <Row styleName="crowdfunding-banner">
          <Col
            md="auto"
            styleName={isMoneyPool ? 'banner-text-money-pool' : 'banner-text'}
          >
            {!isMoneyPool && (
              <Icon
                name={bannerIcon || 'donate'}
                styleName="crowdfunding-banner-icon"
              />
            )}
            {isMoneyPool ? (
              <MoneyPoolHeader
                bannerLink={bannerLink}
                bannerTitleText={bannerTitleText}
                clickUrl={analytics?.clickUrl}
              />
            ) : (
              <HeadingText size="md">
                {bannerTitleText || i18n('crowdfunding_banner_info')}
              </HeadingText>
            )}
          </Col>
          <Col md="auto">
            {!isMoneyPool && (
              <Button
                onClick={this.handleHelpNow}
                secondary
                size="sm"
                styleName="crowdfunding-banner-button"
                to={this.props.cta}
              >
                {bannerButtonText || i18n('crowdfunding_banner_cta')}
              </Button>
            )}
          </Col>
        </Row>
      </Container>
    )
  }
}

export default cssModules(CrowdfundingBanner, styles)
